function multiplyDiscountCoupons(){
  const form = document.querySelector('form[data-testid="formDiscountCoupon"]');
  if (!form) return;

  const originalInput = form.querySelector('#discountCouponCode');
  if (!originalInput) return;

  // Hide the original input so it is not visible
  originalInput.style.position = "absolute";
  originalInput.style.width = "1px";
  originalInput.style.height = "1px";
  originalInput.style.padding = "0";
  originalInput.style.margin = "-1px";
  originalInput.style.border = "0";
  originalInput.style.clip = "rect(0,0,0,0)";
  originalInput.style.overflow = "hidden";
  originalInput.style.whiteSpace = "nowrap";
  form.querySelector(".btn-secondary").style.display = "none"
  
  // Create the main container for coupon elements
  const additionalCouponsDiv = document.createElement("div");
  additionalCouponsDiv.id = "additionalCoupons";

  // First input for coupon
  const firstInput = document.createElement("input");
  firstInput.type = "text";
  firstInput.className = "form-control";
  firstInput.placeholder = "Kód poukazu";
  firstInput.style.marginTop = "5px";

  // Button to add another coupon
  const addCouponBtn = document.createElement("button");
  addCouponBtn.type = "button";
  addCouponBtn.textContent = "Přidat další poukaz";
  addCouponBtn.className = "btn btn-light";
  addCouponBtn.style.margin = "10px 0";

  // Button to submit all coupons
  const submitBtn = document.createElement("button");
  submitBtn.type = "button";
  submitBtn.textContent = "Uplatnit všechny poukazy";
  submitBtn.className = "btn btn-secondary";
  submitBtn.style.display = "block";
  submitBtn.style.marginTop = "10px";

  // Container for error messages
  const errorDiv = document.createElement("div");
  errorDiv.id = "couponError";
  errorDiv.style.color = "red";
  errorDiv.style.marginTop = "5px";

  // Add all elements to the main container in the correct order
  additionalCouponsDiv.appendChild(firstInput);
  let addCouponBtnAdded = false;

  firstInput.addEventListener("input", function() {
    const val = firstInput.value.trim();
    if (val.length >= 3) {
      if (!addCouponBtnAdded) {
        additionalCouponsDiv.insertBefore(addCouponBtn, submitBtn);
        addCouponBtnAdded = true;
      }
    } else {
      if (addCouponBtnAdded) {
        additionalCouponsDiv.removeChild(addCouponBtn);
        addCouponBtnAdded = false;
      }
    }
  });

  additionalCouponsDiv.appendChild(submitBtn);
  additionalCouponsDiv.appendChild(errorDiv);

  // Insert our container after the form
  form.insertAdjacentElement("afterend", additionalCouponsDiv);

  function updateSubmitBtnText() {
    const inputsCount = additionalCouponsDiv.querySelectorAll("input").length;
    if (inputsCount > 1) {
      submitBtn.textContent = "Uplatnit všechny poukazy";
    } else {
      submitBtn.textContent = "Uplatnit";
    }
  }

  // After adding the first input, update the submit button text
  updateSubmitBtnText();

  // Add more coupon inputs when clicking the add button
  addCouponBtn.addEventListener("click", () => {
    const newInput = document.createElement("input");
    newInput.type = "text";
    newInput.className = "form-control";
    newInput.placeholder = "Kód poukazu";
    newInput.style.marginTop = "5px";
    additionalCouponsDiv.insertBefore(newInput, addCouponBtn);

    updateSubmitBtnText();
  });

  // Clicking the submit button sends data via fetch
  submitBtn.addEventListener("click", async () => {
    errorDiv.textContent = "";

    // Collect all coupons from new inputs (do not use the original hidden input)
    const discountCodes = Array.from(additionalCouponsDiv.querySelectorAll("input"))
      .map(input => input.value.trim())
      .filter(code => code !== "");
   
    if (discountCodes.length === 0) {
      errorDiv.textContent = "Prosím zadejte alespoň jeden kupón.";
      return;
    }

    const payload = {
      discountCodes,
      price: getShoptetDataLayer("cartInfo").getNoBillingShippingPrice.withVat // optionally dynamic
    };

    try {
      const response = await fetch("https://drexiss.mirandamedia.agency/api/discounts", {
        method: "POST",
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.status === "success" && data.applyDiscountCode) {
        originalInput.value = data.applyDiscountCode;
        errorDiv.textContent = "Kupón úspěšně přidán!";
        setTimeout(function() {
          form.submit()
        }, 1);
      } else if (data.status === "error" && data.error && data.error.cs) {
        errorDiv.textContent = data.error.cs;
      } else {
        errorDiv.textContent = "Nastala chyba při přidávání kupónu.";
      }
    } catch (e) {
      errorDiv.textContent = "Chyba sítě, zkuste to prosím znovu.";
      console.error(e);
    }
  });
}
export{multiplyDiscountCoupons}